import styled from 'styled-components';
import { useParams, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { BackArrow } from 'lib/styles/icons';
import { Link } from '../../../node_modules/react-router-dom/index';

const DeviceRegisterSpace = () => {
  const navigate = useNavigate();
  const { floor } = useParams();
  const { planList } = useSelector(({ device }) => device);
  const spaceList = planList.filter(plan => plan.floor === floor)[0].space;

  return (
    <DeviceRegisterSpaceBlock>
      <div className="device-register-space-header">
        <BackArrow
          className="device-register-space-back-icon"
          onClick={() => navigate(-1)}
        />
        <div style={{ marginLeft: 20, fontWeight: 500, fontSize: 18 }}>
          {floor}
        </div>
      </div>
      <div className="device-register-space-item-wrapper">
        {spaceList.map((space, idx) => (
          <Link key={idx} to={space.name}>
            <DeviceRegisterSpaceItem>{space.name}</DeviceRegisterSpaceItem>
          </Link>
        ))}
      </div>
    </DeviceRegisterSpaceBlock>
  );
};

export default DeviceRegisterSpace;

const DeviceRegisterSpaceBlock = styled.div`
  margin-top: 1rem;

  .device-register-space-header {
    margin-bottom: 1rem;
    display: flex;
    align-items: center;
  }

  .device-register-space-back-icon {
    margin-left: 1rem;
    font-size: 22px;
  }

  .device-register-space-item-wrapper {
    display: inline-flex;
    flex-wrap: wrap;
    gap: 18px;
  }
`;

const DeviceRegisterSpaceItem = styled.div`
  width: 100px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-size: 14px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.1);
  cursor: pointer;
`;
